import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsApacheopenofficeComponent } from './simple-icons-apacheopenoffice.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsApacheopenofficeComponent ],
    exports:      [ SimpleIconsApacheopenofficeComponent ],
    bootstrap:    []
})
export class SimpleIconsApacheopenofficeModule {}
